// src/pages/AdministrateModules.js

import React, { useEffect, useState } from 'react';
import { fetchModules, addModule, updateModule, deleteModule, fetchLevels } from '../services/dataFetch';

const AdministrateModules = () => {
  const [modules, setModules] = useState([]);
  const [levels, setLevels] = useState([]);
  const [form, setForm] = useState({ name: '', level_id: '' });
  const [editId, setEditId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [message, setMessage] = useState('');

  const loadModules = async () => {
    try {
      const data = await fetchModules();
      setModules(data);
    } catch {
      setMessage('Failed to load modules');
    }
  };

  const loadLevels = async () => {
    try {
      const data = await fetchLevels();
      setLevels(data);
    } catch {
      setMessage('Failed to load levels');
    }
  };

  useEffect(() => {
    loadModules();
    loadLevels();
  }, []);

  const handleInputChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleEditChange = (e) => setEditForm({ ...editForm, [e.target.name]: e.target.value });

  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      await addModule(form);
      setForm({ name: '', level_id: '' });
      setMessage('Module added');
      loadModules();
    } catch {
      setMessage('Error adding module');
    }
  };

  const handleUpdate = async (id) => {
    try {
      await updateModule(id, editForm);
      setEditId(null);
      setMessage('Module updated');
      loadModules();
    } catch {
      setMessage('Error updating module');
    }
  };

  const handleDelete = async (id) => {
    // Single confirmation
    if (!window.confirm('Are you sure you want to delete this module?')) {
      return;
    }

    try {
      // Always use force=true to delete module and its dependencies
      await deleteModule(id, true);
      setMessage('Module deleted successfully!');
      loadModules();
    } catch (err) {
      console.error(err);
      const errorMessage = err.message || 'Error deleting module';
      setMessage(errorMessage);
    }
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h2>Administrate Modules</h2>

      <form onSubmit={handleAdd} style={{ marginBottom: '2rem' }}>
        <input
          name="name"
          placeholder="Module name (e.g. Written)"
          value={form.name}
          onChange={handleInputChange}
          required
        />
        <select
          name="level_id"
          value={form.level_id}
          onChange={handleInputChange}
          required
        >
          <option value="" disabled>
            Select Level
          </option>
          {levels.map(level => (
            <option key={level.id} value={level.id}>
              {level.name}
            </option>
          ))}
        </select>
        <button type="submit">Add Module</button>
      </form>

      {message && <p>{message}</p>}

      <table border="1" cellPadding="8" style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th>Module Name</th>
            <th>Level</th>
            <th style={{ width: '200px' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {modules.map((module) =>
            editId === module.id ? (
              <tr key={module.id}>
                <td>
                  <input
                    name="name"
                    value={editForm.name}
                    onChange={handleEditChange}
                  />
                </td>
                <td>
                  <select
                    name="level_id"
                    value={editForm.level_id}
                    onChange={handleEditChange}
                    required
                  >
                    <option value="" disabled>Select Level</option>
                    {levels.map(level => (
                      <option key={level.id} value={level.id}>{level.name}</option>
                    ))}
                  </select>
                </td>
                <td>
                  <button onClick={() => handleUpdate(module.id)}>Save</button>
                  <button onClick={() => setEditId(null)}>Cancel</button>
                </td>
              </tr>
            ) : (
              <tr key={module.id}>
                <td>{module.name}</td>
                <td>{module.level?.name || 'N/A'}</td>
                <td>
                  <button onClick={() => { setEditId(module.id); setEditForm(module); }}>
                    Edit
                  </button>
                  <button onClick={() => handleDelete(module.id)}>Delete</button>
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AdministrateModules;
